module.exports = __webpack_public_path__ + "img/openid-logo.705c93cd.svg";